export const RiskScoringModel = {
  ControlEffectivenessAverages: 'control_effectiveness_averages',
  Default: 'default',
  NumberOfControlsWithGaps: 'number_of_controls_with_gaps',
  /**
   * Tier roll-up driven purely by risk-assessment judgment, with no control
   * linkage feeding the score (RSP-1349). Like Default, T3 scores come from
   * the risk assessment (likelihood × impact); unlike Default it aggregates
   * up the tier hierarchy by averaging likelihood and impact separately.
   */
  RiskAggregationOnly: 'risk_aggregation_only',
  TypedControlEffectivenessAverages: 'typed_control_effectiveness_averages',
} as const;

export type RiskScoringModel =
  (typeof RiskScoringModel)[keyof typeof RiskScoringModel];
